import { cacheTypes, getMethodByCallBack, postMethodByCallBack, postMethodByDispatcher } from "../../../store/api/CommonFunctions"

export function getNextNumber(onGet) {
    getMethodByCallBack("api/DisassemblyAPI/GetNextNumber", cacheTypes.NoCache, onGet, "GetNextNumber");
}
export function searchDisassembly(data) {
    return dispatch => {
        dispatch({
            type: "DISASSEMBLY_SEARCH_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher("api/DisassemblyAPI/SearchDisassembly", data, "GET_DISASSEMBLY_LIST", "جستجوی فرم های مونتاژ"));
    }
}
export function getDisassembly(id, onGet) {
    getMethodByCallBack(`api/DisassemblyAPI/GetDisassembly?id=${id}`, cacheTypes.NoCache, onGet, "GetDisassembly");
}
export function deleteDisassembly(id, onDelete) {
    getMethodByCallBack(`api/DisassemblyAPI/DeleteDisassembly?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteDisassembly");
}
export function addEditDisassembly(data, onAddEdit) {
    postMethodByCallBack("api/DisassemblyAPI/AddEditDisassembly", data, onAddEdit, "AddEditDisassembly");
}